import { forwardRef, ComponentPropsWithoutRef, ReactNode } from "react";
import clsx from "clsx";
import ErrorBoundary from "../error-boundary";

import styles from "./menu.module.scss";
import { SizeProps } from "../sizes";

const variants = {
  left: "menuLeft",
  top: "menuTop",
};

const sizeMap = { m: "auMedium", l: "auLarge" };

type Variants = typeof variants;

type MenuProps = {
  variant?: keyof Variants;
  /** Optional extra class(es) */
  className?: string;

  /** The menu items of the menu */
  children: ReactNode;
} & ComponentPropsWithoutRef<"ul"> &
  SizeProps;

const _Menu = forwardRef<HTMLUListElement, MenuProps>(
  ({ variant = "left", className, children, size = "m", ...rest }, ref) => {
    const variantClass = variants[variant];
    const classes = [styles.menu, styles[variantClass], className];

    return (
      <ErrorBoundary>
        <ul ref={ref} className={clsx(classes, sizeMap[size])} {...rest}>
          {children}
        </ul>
      </ErrorBoundary>
    );
  }
);

const Menu = Object.assign(_Menu, {
  variants: Object.keys(variants).reduce(
    (obj, key) => ({ ...obj, [key]: key }),
    {}
  ) as RecordKeys<Variants>,
});

Menu.displayName = "Menu";

export default Menu;
